import PickItem from "./pick-item";

function getSortedItemList(itemList) {
    if (!itemList || !itemList.length) {
        return [];
    }
    let arr = itemList.map(item => PickItem.getInstanceFromItem(item));
    arr = arr.sort(function(a, b){return a.sequence - b.sequence});
    return arr;
}

export default class Picklist {

    /***
     *
     * @param{PicklistInfo} picklistInfo
     */
    static getInstance(picklistInfo) {
        const picklistDetail = new Picklist();
        picklistDetail.id = picklistInfo.id;
        picklistDetail.itemList = getSortedItemList(picklistInfo.itemList);
        picklistDetail.status = picklistInfo.status;
        picklistDetail.routeCode = picklistInfo.code;
        picklistDetail.routeAisles = picklistInfo.aisles;
        picklistDetail.stagingArea = picklistInfo.stagingArea;
        picklistDetail.chutes = picklistInfo.chutes;
        picklistDetail.executionMode = picklistInfo.executionMode;
        picklistDetail.scannedContent = picklistDetail.routeCode;
        return picklistDetail;
    }
}


// WEBPACK FOOTER //
// ./src/models/ui/picklist.js